import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppState } from '../../context/AppStateContext'; // Use your custom hook
import { CookieManager } from '../../utils/CookieManager';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { state } = useAppState(); // Use your custom hook
  const user = state.user;
  const token = state.token;
  
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const storedToken = localStorage.getItem('token');
      const authCookie = CookieManager.get('authToken');
      
      const hasAuth = !!(user || token || storedToken || authCookie);
      setIsAuthenticated(hasAuth);
      setIsChecking(false);
    };

    // Add a small delay to ensure auth state is loaded
    const timer = setTimeout(checkAuth, 200);
    return () => clearTimeout(timer);
  }, [user, token]);

  // Show loading while checking authentication
  if (isChecking) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to home if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};